import { api } from "@/api";
import { QueryProps } from "@/types/Api";
import { OddsHistoryMatchTimeline } from "@/types/ApiResponses/OddsHistory";

export interface OddsHistoryMatchParams {
  matchKey: string;
  marketGroup?: number;
  lang: string;
}

export const getOddsHistoryMatch = async (
  props: QueryProps<OddsHistoryMatchParams>
): Promise<OddsHistoryMatchTimeline> => {
  const { matchKey, ...params } = props.params;
  const res = await api.client.get(
    `/odds-history/matches/${encodeURIComponent(matchKey)}`,
    { signal: props.signal, params }
  );
  return res.data;
};
